module.exports = __webpack_public_path__ + "static/media/icons8-azure.d36fd641.svg";